import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Timer, AlertTriangle } from 'lucide-react';

const DeadlineStatsWidget = ({ deadlineStats }) => {
  const navigate = useNavigate();

  if (!deadlineStats || deadlineStats.total_with_deadline === 0) return null;

  return (
    <Card className="border-0 shadow-xl" data-testid="deadline-stats-section">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Timer className="h-5 w-5 text-indigo-600" />
          Statistiques des delais
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-4">
          <div className="bg-indigo-50 rounded-xl p-3 text-center border border-indigo-100">
            <p className="text-2xl font-black text-indigo-700">{deadlineStats.total_with_deadline}</p>
            <p className="text-xs text-indigo-500 font-medium">Total avec delai</p>
          </div>
          <div className="bg-green-50 rounded-xl p-3 text-center border border-green-100">
            <p className="text-2xl font-black text-green-700">{deadlineStats.on_time}</p>
            <p className="text-xs text-green-500 font-medium">Dans les delais</p>
          </div>
          <div className="bg-orange-50 rounded-xl p-3 text-center border border-orange-100">
            <p className="text-2xl font-black text-orange-700">{deadlineStats.attention}</p>
            <p className="text-xs text-orange-500 font-medium">Bientot expire</p>
          </div>
          <div className="bg-red-50 rounded-xl p-3 text-center border border-red-100">
            <p className="text-2xl font-black text-red-700">{deadlineStats.late}</p>
            <p className="text-xs text-red-500 font-medium">En retard</p>
          </div>
          <div className={`rounded-xl p-3 text-center border ${deadlineStats.respect_percentage >= 80 ? 'bg-green-50 border-green-100' : deadlineStats.respect_percentage >= 50 ? 'bg-orange-50 border-orange-100' : 'bg-red-50 border-red-100'}`}>
            <p className={`text-2xl font-black ${deadlineStats.respect_percentage >= 80 ? 'text-green-700' : deadlineStats.respect_percentage >= 50 ? 'text-orange-700' : 'text-red-700'}`}>
              {deadlineStats.respect_percentage}%
            </p>
            <p className="text-xs text-gray-500 font-medium">Respect des delais</p>
          </div>
        </div>
        {deadlineStats.most_late && deadlineStats.most_late.length > 0 && (
          <div>
            <p className="text-xs font-bold text-red-600 mb-2 flex items-center gap-1">
              <AlertTriangle className="h-3 w-3" /> Dossiers les plus en retard
            </p>
            <div className="space-y-1">
              {deadlineStats.most_late.slice(0, 5).map((f) => (
                <div
                  key={f.file_id}
                  className="flex items-center justify-between bg-red-50 rounded-lg px-3 py-2 text-xs cursor-pointer hover:bg-red-100 transition-colors"
                  onClick={() => navigate(`/files/${f.file_id}`)}
                >
                  <span className="font-semibold text-gray-800">{f.file_number} - {f.client_name}</span>
                  <Badge className="bg-red-600 text-white text-[10px]">
                    Retard: {Math.round(f.delay_hours)}h
                  </Badge>
                </div>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default DeadlineStatsWidget;
